import React from "react";
import { useTranslation } from "react-i18next";
import { FORM_NAME, MODE_FLAG } from "src/constant/common";

const ModalViewInitialCondition = ({ simulationData }) => {
  const { t } = useTranslation("gnc-simulator-6dof");

  const initialConditionData = [
    { key: "initial_model", label: t("new.initial_condition.mode_flag"), isModeFlag: true },
    { key: "initial_position", label: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.POSITION}`), isArray: true },
    { key: "initial_velocity", label: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.VELOCITY}`), isArray: true },
    { key: "initial_euler", label: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ATTITUDE_ANGLE}`), isArray: true },
    { key: "initial_angular_velocity", label: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ANGULAR_VELOCITY}`), isArray: true },
    { key: "initial_engine_state", label: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.ENGINE_STATE}`) },
    { key: "emergency_stop_time", label: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_STOP_TIME}`) },
    { key: "emergency_landing_time", label: t(`new.initial_condition.${FORM_NAME.INITIAL_CONDITION.EMERGENCY_LANDING_TIME}`) },
  ];
  const initialConditionObj = simulationData?.input_data?.initial_condition;

  return (
    <div className="m-3">
      {initialConditionObj &&
        initialConditionData.map(({ key, label, unit, isArray, isModeFlag }) => {
          return (
            <div className="fw-bold mb-3" key={key}>
              <span>{label}</span>
              <span>{initialConditionObj?.[key]?.unit ? ` (${unit || initialConditionObj?.[key]?.unit}) = ` : " = "}</span>
              {isModeFlag && (
                <span>
                  {`${initialConditionObj?.[key]?.value} (${
                    initialConditionObj?.[key]?.value === MODE_FLAG.ASC ? "Ascent Mode" : "Descent Mode"
                  })`}
                </span>
              )}
              {!isModeFlag && (
                <span>{isArray ? `[${initialConditionObj?.[key]?.value?.join(", ")}]` : initialConditionObj?.[key]?.value}</span>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default ModalViewInitialCondition;
